import React from "react";

export default function Underline({ width = 20, height = 3 }) {
  return (
    <div
      style={{
        width,
        height,
        borderRadius: 12,
        backgroundColor: "#633ccd",
      }}
    ></div>
  );
}
